import { useQuery } from '@tanstack/vue-query'
import { investorsQueryKeys } from '../investorsQueryKeys'
import { getVaspOnboardingStatusCounts } from '../investorsEndpoints'

export function useVaspOnboardingStatusCountsQuery() {
  return useQuery({
    queryKey: investorsQueryKeys.vaspOnboardingStatusCounts(),
    queryFn: getVaspOnboardingStatusCounts,
    staleTime: 1000 * 30,
  })
}
